import { useTheme } from "@emotion/react";

import React, { useCallback } from "react";

import PhoneInput from "react-phone-input-2";
import { Typography } from "@mui/material";
import { formatPhoneNumber } from "../../hooks/CommonFunction";

const CustomPhoneContactField = ({
  isError,
  errorText,
  icon,
  label,
  onChange,
  onTextChange,
  inputProps,
  value,
  inputStyle,
  isValid,
  onMount,
  disabled,
  ...rest
}) => {

  const theme = useTheme();
  const handleChange = useCallback(
    (value, country, e, formattedValue) => {
       
      if (!value.startsWith("91")) {
        value = "91" + value.replace(/^(\+)?91/, "");
      }

      const formattedPhoneNumber = formatPhoneNumber(formattedValue);
      onTextChange && onTextChange(formattedPhoneNumber);
      onChange && onChange(formattedPhoneNumber, country, e, formattedValue);
    },
    [onChange, onTextChange]
  );

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <PhoneInput
        defaultErrorMessage={isError}
        onlyCountries={["in"]}
        disableDropdown={true}  
        countryCodeEditable={false}  
        inputProps={{
          name: "Phone No",
        }}
        country={"in"}
      
        value={value}
        onChange={handleChange}
        inputStyle={{
          width: "100%",
          border: isError ? "1px solid red" : "1px solid #ccc",
          color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
          background: theme.palette.contact,
          // marginTop: theme.spacing(2),
        }}
        dropdownStyle={{
          backgroundColor: theme.palette.background?.paper,
        }}
        specialLabel={
          <Typography 
          sx={{
            color: theme.palette.text.primary,
            background: theme.palette.contact,
            position: "absolute",
            // top: theme.spacing(0.7),
            top: theme.spacing(-0.3),
            left: theme.spacing(2),
            display: "block",
            letterSpacing:0,
            fontSize:"0.75rem"
          }}
         
           variant="h6"
          >
            {label || "Contact"}
          </Typography>
        }
        isValid={isValid}
        disabled={disabled}
        {...rest}
      />
      {errorText ? (
        <span style={{ color: "red", textAlign: "right", fontSize: "12px" }}>
          {errorText}
        </span>
      ) : (
        <span></span>
      )}
    </div>
  );
};

export default CustomPhoneContactField;
